import {ModuleConfiguration} from "../router/model/UserPermission";
import {AngularJsMaterialModuleName, OpportunityNotificationModuleName} from "../utils/names/requiredModulesNames";
import {OpportunitiesServiceModuleName} from "../utils/names/optionalModuleNames";

export const OpportunityNotificationModuleConfiguration = new ModuleConfiguration(
    OpportunityNotificationModuleName,
    [AngularJsMaterialModuleName,
        OpportunitiesServiceModuleName]);